import React from 'react';
import AdminSidebar from '../components/AdminSidebar';
import '../styles/admin.css';

const AdminOrders = () => {
  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-header-title">📋 Захиалга Удирдах</h1>
        </div>

        <div className="admin-main">
          <div style={{ textAlign: 'center', padding: '40px', color: '#ddd' }}>
            <p style={{ fontSize: '18px', marginBottom: '15px' }}>⏳ Энэ хэсэг ирээдүйд хөгжүүлэх гэж байна</p>
            <p style={{ fontSize: '14px', color: '#999' }}>Захиалга удирдах функцийн хөгжүүлэлт эхэлнэ</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminOrders;

/*
// ORIGINAL CODE - COMMENTED OUT FOR FUTURE USE
import React, { useState, useEffect } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import '../styles/admin.css';

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    // Mock data
    const mockOrders = [
      { id: 1, customer: 'Батаа', product: 'Mining Drill', amount: 450000, status: 'Амжилттай', date: '2024-04-01' },
      { id: 2, customer: 'Сүхээ', product: 'Heavy Tires', amount: 320000, status: 'Хүлээж байна', date: '2024-04-02' },
      { id: 3, customer: 'Энхцэцэг', product: 'Drilling Bit', amount: 180000, status: 'Илгээгджээ', date: '2024-04-03' },
    ];
    setOrders(mockOrders);
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case 'Амжилттай':
        return { color: '#28a745', background: 'rgba(40, 167, 69, 0.1)' };
      case 'Хүлээж байна':
        return { color: '#ffc107', background: 'rgba(255, 193, 7, 0.1)' };
      case 'Илгээгджээ':
        return { color: '#17a2b8', background: 'rgba(23, 162, 184, 0.1)' };
      default:
        return { color: '#6c757d', background: 'rgba(108, 117, 125, 0.1)' };
    }
  };

  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-header-title">📋 Захиалга Удирдах</h1>
          <span style={{ color: '#ddd' }}>Нийт: {orders.length}</span>
        </div>

        <div className="admin-main">
          {orders.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#ddd' }}>
              <p>Захиалга олдсонгүй</p>
            </div>
          ) : (
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Дугаар</th>
                  <th>Үйлчүүлэгч</th>
                  <th>Бүтээгдэхүүн</th>
                  <th>Дүн</th>
                  <th>Төлөв</th>
                  <th>Огноо</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => {
                  const statusColor = getStatusColor(order.status);
                  return (
                    <tr key={order.id}>
                      <td>#{order.id}</td>
                      <td>{order.customer}</td>
                      <td>{order.product}</td>
                      <td>₮{order.amount.toLocaleString()}</td>
                      <td>
                        <span
                          style={{
                            padding: '5px 10px',
                            borderRadius: '4px',
                            color: statusColor.color,
                            background: statusColor.background,
                            fontSize: '12px',
                            fontWeight: '600',
                          }}
                        >
                          {order.status}
                        </span>
                      </td>
                      <td>{order.date}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminOrders;
*/
